import { render, staticRenderFns } from "./PaymentContainer.pug?vue&type=template&id=8f13c2bc&scoped=true&lang=pug&"
import script from "./PaymentContainer.vue?vue&type=script&lang=js&"
export * from "./PaymentContainer.vue?vue&type=script&lang=js&"
import style0 from "./PaymentContainer.scss?vue&type=style&index=0&id=8f13c2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f13c2bc",
  null
  
)

export default component.exports